import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import LabelType from '@/Controls/Label';

export default class EnumerationLabelFactory extends ControlFactory {

    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    protected Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery<HTMLElement>;
    private sortAlphabetically: KnockoutObservable<boolean>;

    public constructor(params) {
        super(params);

        this.sortAlphabetically = this.observableOrDefault(params.sortAlphabetically, false);
    }

    /**
     * @override
     */
    control: LabelType;
    /**
     * @override
     */
    viewModel: LabelViewModelType;

    /**
     * @override
     */
    public getControl(): JQuery<HTMLElement> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.LabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            caption: this.defineComputed(() => {
                let value = this.context.genericObject.getObservable(this.detailViewItem.name);
                let selectedEnumerationsStr = value();
                let selectedEnumerations = String.isNullOrEmpty(selectedEnumerationsStr) ? [] : selectedEnumerationsStr.split(',');

                let names = [];
                for (let enumeration in this.detailViewItem.possiblePDEnumerationValues) {
                    if (selectedEnumerations.indexOf(enumeration) >= 0) {
                        names.push(ResourceManager.getInstance().get(this.detailViewItem.possiblePDEnumerationValues[enumeration]));
                    }
                }

                if (names.length === 0) {
                    return '-';
                }

                if (this.sortAlphabetically()) {
                    names = names.sort((a: string, b: string) => {
                        return a.localeCompare(b);
                    });
                }

                return names.join(', ');
            })
        });

        this.control = new this.Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.jQueryControl.removeClass('c-label');
        this.jQueryControl.addClass('c-enumerationlabel');

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('EnumerationLabel', EnumerationLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');